import React from 'react'
import styled from 'styled-components'
import { QueryListFilter } from '@feedyou/schema'

import { IconButton } from '../../../../components/Styleguide/Button'

interface Props {
  commitCurrentFilterAsActive(): void
  resetActiveFilter(): void
}

export const ControlButtons: React.FC<Props> = ({
  commitCurrentFilterAsActive,
  resetActiveFilter
}) => {
  return (
    <Wrapper>
      <ControlButton
        iconName="search"
        tooltipText="Filter"
        tooltipPlacement="top"
        onClick={() => commitCurrentFilterAsActive()}
      />
      <ControlButton
        iconName="redo"
        tooltipText="Reset"
        tooltipPlacement="top"
        iconStyle={{ flip: 'horizontal' }}
        onClick={() => resetActiveFilter()}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
`

const ControlButton = styled(IconButton)`
  margin-left: 6px;
`
